var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V4.75724C4.98704 3.22835 6.87876 2.25 9 2.25C12.4427 2.25 15.2825 4.82673 15.6978 8.1572C15.7491 8.56823 15.4574 8.94298 15.0464 8.99424C14.6354 9.04549 14.2606 8.75383 14.2093 8.3428C13.8865 5.75381 11.6767 3.75 9 3.75C7.21673 3.75 5.63999 4.63925 4.69082 6H6.75C7.16421 6 7.5 6.33579 7.5 6.75C7.5 7.16421 7.16421 7.5 6.75 7.5H3C2.58579 7.5 2.25 7.16421 2.25 6.75V3C2.25 2.58579 2.58579 2.25 3 2.25ZM2.95362 9.00576C3.36465 8.95451 3.7394 9.24616 3.79066 9.6572C4.1135 12.2462 6.32332 14.25 9 14.25C10.7833 14.25 12.36 13.3608 13.3092 12H11.25C10.8358 12 10.5 11.6642 10.5 11.25C10.5 10.8358 10.8358 10.5 11.25 10.5H15C15.4142 10.5 15.75 10.8358 15.75 11.25V15C15.75 15.4142 15.4142 15.75 15 15.75C14.5858 15.75 14.25 15.4142 14.25 15V13.2428C13.013 14.7717 11.1212 15.75 9 15.75C5.55726 15.75 2.71749 13.1733 2.30218 9.8428C2.25093 9.43178 2.54259 9.05702 2.95362 9.00576Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.37e1b43610b549e8d2b842a57c10068d.svg";
export { ForwardRef as ReactComponent };